import React from "react";
import { Grid } from "semantic-ui-react";
import CategoryInput from "../CategoryInput";
import ProductInput from "../ProductInput";

function CategoryAndProductInput() {
	return (
		<Grid
			columns={2}
			style={{
				marginBottom: "0px",
				marginTop: "0px",
			}}
		>
			<Grid.Column>
				<CategoryInput />
			</Grid.Column>
			<Grid.Column>
				<ProductInput />
			</Grid.Column>
		</Grid>
	);
}

export default CategoryAndProductInput;
